export default __webpack_public_path__ + "static/media/checkmark.de36f408.svg";